import { randomId } from "@mantine/hooks";

import { type IMedicalInput } from "../../components/pages/Settings/YachtSetUp/MedicalHistory/sections/MedicalSections.model";

export const insertId = (input: IMedicalInput) => ({
  ...input,
  id: randomId(),
});
export const clearInput = (input: IMedicalInput) => ({
  ...input,
  value:
    input.unit === "attachment"
      ? []
      : input.unit === "sig/acceptance"
        ? null
        : "",
  id: randomId(),
});
